<template>
  <div>
    <EmptyLayout v-if="source != 'v2'"> 未找到该页面 </EmptyLayout>

    <div v-else>未找到该页面</div>
  </div>
</template>

<script>
import EmptyLayout from "@/layout/basic/empty";

export default {
  name: "noFound",
  components: {
    EmptyLayout,
  },
  data() {
    return {
      source: "",
    };
  },
  mounted() {
    this.source = this.$route.query.source;
  },
};
</script>

<style scoped></style>
